import isArray from 'lodash/isArray'
import map from 'lodash/map'

const normalizeKeyValuePair = (value, key) => {
  return key + ': ' + normalizeValue(value)
}

const normalizeValue = (value) => {
  return isArray(value) ? value.join(' ') : value
}

// https://github.com/stemkoski/A-Frame-Examples/blob/master/js/joystick.js
export default (optionsObject) => {
  return map(optionsObject, normalizeKeyValuePair).join('; ') + ';'
}
